module.exports = "<label class=\"archi-label\">{{$ctrl.label}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.dateValue\" name=\"{{$ctrl.name}}\"\n    uib-datepicker-popup=\"{{$ctrl.dateFormat}}\" datepicker-options=\"$ctrl.options\"\n    ng-click=\"$ctrl.openDP($event)\" ng-change=\"$ctrl.change()\" ng-required=\"$ctrl.isRequired\"\n    is-open=\"$ctrl.isOpened\" ng-focus=\"$ctrl.autoOpen($event)\"\n    close-text=\"Chiudi\" clear-text=\"Pulisci\" current-text=\"Oggi\">\n<i class=\"fa fa-calendar\"></i>";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/calendar/calendar-component.html
// module id = 1339
// module chunks = 0